export default __webpack_public_path__ + "static/view_02-25_4-619c3bd53c20c37faf87ae7d8d7177e4.jpg";